import script from "./SuccessMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SuccessMessage.vue?vue&type=script&setup=true&lang=ts"

import "./SuccessMessage.vue?vue&type=style&index=0&id=9f836b7a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f836b7a"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
